import {ChangeDetectorRef, Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {UiModelService} from '../../services/ui-model.service';
import {Observable, Subscription, switchMap} from 'rxjs';
import {distinctUntilChanged, filter, map, take, tap} from 'rxjs/operators';
import {UiVorgang} from '../../models/uiVorgang';
import {MenuService} from '../../services/menu.service';
import {EventService} from '../../services/event.service';
import {UILayout} from '../../models/uiLayout';
import {ValidationService} from '../../services/validation.service';
import {UIContainerControl, UIMenu} from '../../models/uiArtefakt';
import {ShellConfigService} from '../../services/shell-config.service';
import {UiContainerSpalte} from '../../models/uiContainerSpalte';
import {MenuWorkflowService} from '../../services/menu-workflow.service';
import {MenuStateService} from '../../services/menu-state.service';
import {UIArtefaktTyp} from '../../models/uiArtefaktTyp';
import {AsyncUirefService} from '../../services/async-uiref.service';
import {EventFondsService} from '../../services/event-fonds.service';
import {Notification, NotificationService, RuntimeContext} from '@lv1871/core';
import {TrackingService} from '../../services/tracking.service';

@Component({
    selector: 'lv-antrag',
    templateUrl: 'antrag.component.html',
    styleUrls: ['antrag.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AntragComponent implements OnInit, OnDestroy {
  public uiModelObjectsObs$: Observable<UiVorgang>;
  public menu$: Observable<UIMenu>;
  public isLoading: boolean = true;
  public uiLayoutEnum = UILayout;
  public uiLayout = UILayout.NAVIGATION_MENU;
  public uiAusrichtung;
  public uiVorgangLayoutSpalte = UiContainerSpalte;
  public initialised = false;
  public showLeftColumn: boolean = true;
  public showRightColumn: boolean = true;
  public isSBShell: boolean;

  private _subscription: Subscription = Subscription.EMPTY;

  public constructor(private _eventService: EventService,
                     private _eventFondsService: EventFondsService,
                     private _uiModelService: UiModelService,
                     private _notificationService: NotificationService,
                     private _componentFactoryResolver: ComponentFactoryResolver, private _menuStateService: MenuStateService,
                     private _validationService: ValidationService, public _menuService: MenuService, private _cdRef: ChangeDetectorRef,
                     private _shellConfigService: ShellConfigService, private _menuWorkflowService: MenuWorkflowService,
                     private _asyncUiRefService: AsyncUirefService,
                     private _tracker: TrackingService) {
  }

  public ngOnInit() {
    this.isSBShell = this._shellConfigService.getParameter().runtimeContext === RuntimeContext.SB_SHELL;
    this.menu$ = this._eventService.menu$;

    this.uiModelObjectsObs$ = this._eventService.uiUpdateRequest$.pipe(
        map(uiControl => uiControl.uiVorgang),
        tap(uiVorgang => {
          this.isLoading = false;
          this._shellConfigService.designerParameter = uiVorgang.UIParameter;
          if (!!this._shellConfigService.getParameter().uiLayout) {
            this.uiLayout = this._shellConfigService.getParameter().uiLayout;
          }
          if (!!this._shellConfigService.getParameter().uiAusrichtung) {
            this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
          }
          this._asyncUiRefService.resolveAsyncUiRefs(uiVorgang);
          this.showLeftColumn = uiVorgang.UIArtefakt
              .filter(artefakt => artefakt.UIArtefakttyp === UIArtefaktTyp.UI_CONTAINER)
              .filter(artefakt => (artefakt as UIContainerControl).UIContainerComponent === UiContainerSpalte.SPALTE_LINKS)
              .map(_ => this._shellConfigService.getParameter().showMenu && !this._shellConfigService.shellParameter?.variantenvergleich &&
                  this._shellConfigService.getParameter().uiLayout === UILayout.NAVIGATION_MENU)[0];
          this.showRightColumn = uiVorgang.UIArtefakt
              .filter(artefakt => artefakt.UIArtefakttyp === UIArtefaktTyp.UI_CONTAINER)
              .filter(artefakt => (artefakt as UIContainerControl).UIContainerComponent === UiContainerSpalte.SPALTE_RECHTS)
              .map(_ => !this._shellConfigService.shellParameter?.variantenvergleich)[0];
          this._menuService.createMenu(uiVorgang);
        }),
    );

    this._eventService.variantenvergleichData$.pipe(
        tap(variantenvergleich => {
          this._shellConfigService.shellParameter.variantenvergleichData = variantenvergleich;
          this.init();
        }),
        switchMap(_ => this._uiModelService.requestUiControl().pipe(tap(res => this.isLoading = res))),
        take(1)
    ).subscribe();

    this._subscription = this._eventService.urlParams$.pipe(
        filter(_ => !this._shellConfigService.shellParameter?.variantenvergleich),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        tap(_ => this.init()),
        switchMap(uiControl => this._eventService.antragBearbeiten$.pipe(
            take(1),
            map(data => {
              if (!!data) {
                this._eventService.antragBearbeiten$.next(null);
                return data.uiControl;
              } else {
                return uiControl;
              }
            })
        )),
        switchMap(uiControl => this._uiModelService.requestUiControl(uiControl).pipe(tap(res => this.isLoading = res)))
    ).subscribe();
  }

  public init() {
    this._tracker.init();
    this._eventService.init();
    this._notificationService.init();
    this._eventFondsService.init();
    this._menuWorkflowService.init();
    this._menuStateService.init();
    this.initialised = false;
    this._cdRef.detectChanges();
    this.initialised = true;
    this._cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

}
